import { render, staticRenderFns } from "./RequestInformation.vue?vue&type=template&id=80141050&scoped=true&"
import script from "./RequestInformation.vue?vue&type=script&lang=js&"
export * from "./RequestInformation.vue?vue&type=script&lang=js&"
import style0 from "./RequestInformation.vue?vue&type=style&index=0&id=80141050&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80141050",
  null
  
)

export default component.exports